<template>
    <div>
        <table class="kgr-table kgr-table--striped table-groups kgr-row honors">
            <thead>
                <tr class="kgr-table__row">
                    <th
                        v-t="'memberHonor'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th
                        v-t="'Verliehen am'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th class="kgr-table__cell kgr-table__cell--headline"></th>
                </tr>
            </thead>
            <tbody>
                <template v-for="honor in honors">
                    <kgr-member-honor-edit-row
                        :honor="honor"
                        :edit-honors="editHonors"
                        @remove="remove(honor)"
                    />

                    <kgr-member-honor-show-row
                        :honor="honor"
                        :edit-honors="editHonors"
                        :is-deletable="isDeletable"
                        :is-editable="isEditable"
                        @edit="edit(honor)"
                        @remove="remove(honor)"
                    />
                </template>

                <tr
                    v-if="isCreatable"
                    class="kgr-table__row"
                >
                    <td class="kgr-table__cell">
                        <kgr-member-honor-select
                            v-model="newHonor.parameterValue"
                            :club-id="clubId"
                        />
                    </td>
                    <td class="kgr-table__cell">
                        <div
                            class="form-widget without-label date-picker"
                            :class="{ invalid: !newHonor.isEmpty() && (!newHonor.on) }"
                        >
                            <kgr-date-picker v-model="newHonor.on" />
                        </div>
                    </td>
                    <td class="kgr-table__cell">
&nbsp;
                    </td>
                </tr>
            </tbody>
        </table>
        <kgr-button
            v-if="isEditable || isCreatable"
            class="button_save"
            :value="$t('saveChanges')"
            :disabled="!isSavable()"
            :pending="pendingCreate || pendingUpdate"
            @click="save()"
        />
    </div>
</template>

<script>
import DatePicker from '../../common/form/picker/DatePicker';
import KgrButton from '../../common/form/button/KgrButton';
import MemberHonor from '../../../js/dto/MemberHonor';
import MemberHonorEditRow from './MemberHonorEditRow';
import MemberHonorSelect from './MemberHonorSelect';
import MemberHonorShowRow from './MemberHonorShowRow';
import MemberRepository from '../../../js/repository/MemberRepository';

const HTTP_STATUS_CONFLICT = 409;

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-member-honor-select': MemberHonorSelect,
        'kgr-member-honor-edit-row': MemberHonorEditRow,
        'kgr-member-honor-show-row': MemberHonorShowRow,
        'kgr-button': KgrButton,
    },
    props: {
        honors: {
            type: Array,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            newHonor: new MemberHonor(),
            editHonors: [],
            pendingCreate: false,
            pendingUpdate: false,
        }
    },
    methods: {
        isSavable() {
            if (this.editHonors.length === 0 && this.newHonor.isEmpty()) {
                return false;
            }

            let hasInvalidEdits = this.editHonors.filter(editHonor => !editHonor.isValid()).length > 0;
            if (hasInvalidEdits) {
                return false;
            }

            if (!this.newHonor.isEmpty() && !this.newHonor.isValid()) {
                return false;
            }

            return true;
        },
        remove(honor) {
            showConfirm(this.$t('confirm'), this.$t('memberHonor.confirm.delete', {'name': honor.parameterValue.value}), () => {
                this.editHonors = this.editHonors.filter(r => r.id !== honor.id);
                MemberRepository
                    .removeMemberHonor(this.memberId, honor.id)
                    .then(() => {
                        this.$notify.success('memberHonor.delete.success', {'name': honor.parameterValue.value});
                        this.emitUpdated();
                    })
                    .catch(() => {
                        this.$notify.error('saveChanges.error');
                    });
            }, 'Ok');
        },
        edit(honor) {
            this.editHonors.push(honor);
        },
        save() {
            if (!this.newHonor.isEmpty()) {
                this.create();
            }

            if (this.editHonors.length > 0) {
                this.update();
            }
        },
        create() {
            this.pendingCreate = true;
            MemberRepository
                .createMemberHonor(this.memberId, this.newHonor)
                .then(() => {
                    this.newHonor = new MemberHonor();
                    this.$notify.success('saveChanges.success');
                    this.emitUpdated();
                })
                .catch(error => {
                    if (error.status === HTTP_STATUS_CONFLICT) {
                        this.$notify.error('memberHonor.saveChanges.conflict', {'name': this.newHonor.parameterValue.value});
                    } else {
                        this.$notify.error('saveChanges.error');
                    }
                })
                .finally(() => this.pendingCreate = false);
        },
        update() {
            this.pendingUpdate = true;
            MemberRepository
                .updateMemberHonors(this.memberId, this.editHonors)
                .then(() => {
                    this.editHonors = [];
                    this.$notify.success('saveChanges.success');
                    this.emitUpdated();
                })
                .catch(() => this.$notify.error('saveChanges.error'))
                .finally(() => this.pendingUpdate = false);
        },
        emitUpdated() {
            this.$emit('updated');
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .button_save {
        display: block;
        margin-left: auto;
    }

    div .date-picker {
        border: 1px solid transparent;

        &.invalid {
            border: 1px solid #F44336;
        }
    }

    .kgr-table__cell  {
        vertical-align: top;
    }

    .notice-cell {
        width: 60%;
    }
</style>
